module.exports = __webpack_public_path__ + "static/media/avatar_12.ab5a69c7.svg";